import { useCallback, useState, useEffect } from 'react'

import { selectComponentTypes } from 'constants/tableConstants'

export const useCheckbox = (
  data,
  handleCheckBox,
  selectComponent,
  checkedKey = 'checked'
) => {
  const [checkboxState, setCheckboxState] = useState(data)

  const handleSelectState = useCallback(
    (id) => {
      const _checkBoxState = checkboxState.map((i) => {
        if (i.id === id) return { ...i, [checkedKey]: !i[checkedKey] }

        return selectComponent === selectComponentTypes.checkbox
          ? i
          : { ...i, [checkedKey]: false }
      })

      setCheckboxState(_checkBoxState)

      if (typeof handleCheckBox === 'function') handleCheckBox(_checkBoxState)
    },
    [checkedKey, checkboxState, handleCheckBox, selectComponent]
  )

  useEffect(() => {
    setCheckboxState(data)
  }, [data])

  return [checkboxState, handleSelectState]
}
